export default __webpack_public_path__ + "static/media/login_banner_logged_out.1d6adaed.jpg";